<div class="chart chart-container" id="container">
  <div
    class="chartTitle"
    [ngClass]="[!hasEdit ? 'preview' : '']"
    *ngIf="!preview"
  >
    <div
      class="title"
      style="height: 30px; width: 85%"
      matTooltip="{{ title }}"
      matTooltipPosition="right"
    >
      {{ title }}
    </div>
    <fa-icon
      [icon]="faCircleInfo"
      class="pencil customInfoIcon"
      *ngIf="description"
      matTooltip="Description: {{ description }}"
      matTooltipPosition="right"
      matTooltipClass="report-home-tooltip"
    ></fa-icon>
  </div>
  <div class="chartTitle" *ngIf="preview">
    <div
      class="title"
      style="height: 30px; width: 85%; margin-left: -30px"
      matTooltip="{{ title }}"
      matTooltipPosition="right"
    >
      {{ title }}
    </div>
    <fa-icon
      [icon]="faCircleInfo"
      class="pencil customInfoIcon"
      *ngIf="description"
      matTooltip="Description: {{ description }}"
      matTooltipPosition="right"
      matTooltipClass="report-home-tooltip"
    ></fa-icon>
  </div>
  <ng-container *ngIf="!showChart && data != 'empty'">
    <div class="noData">
      <span class="blank_img">
        <fa-icon *ngIf="chartIcon" [icon]="chartIcon"></fa-icon>
        <ng-container *ngIf="hasEdit">
          <div
            *ngIf="
              (!preview || hasEdit) &&
              dataPoints.data &&
              dataPoints.data.length <= 0
            "
          >
            Choose one or more fields and one grouping field to display in this
            {{ type && type.toLowerCase() }} chart
          </div>
          <div
            *ngIf="dataPoints && dataPoints.data && dataPoints.data.length >= 1"
          >
            There is no data to display<br />
            Review Chart Settings or Filters if this is unexpected
          </div>
          <div
            *ngIf="preview && dataPoints.data && dataPoints.data.length <= 0"
          >
            No visible fields to display
          </div>
        </ng-container>
      </span>
    </div>
  </ng-container>

  <ng-container *ngIf="showChart">
    <div class="chart-wrapper">
      <highcharts-chart
        [Highcharts]="Highcharts"
        [options]="chartOptions"
        [(update)]="update"
        [oneToOne]="oneToOne"
        style="width: 100%; height: 100%; display: inline-block"
      >
      </highcharts-chart>
    </div>  
    <ng-container *ngIf="pageLinking"
      ><span class="pageLinking"
        >Drilldown page linking is enabled</span
      ></ng-container
    >
  </ng-container>
</div>
